import styled from "styled-components/macro";

export const StyledContainer = styled.div`
  position: absolute;
  top: 52px;
  z-index: 100000;
  background: var(--menu-color);
  padding: 15px;
  width: 174px;
  text-align: left;
  border-radius: 20px;
  box-shadow: var(--default-drop-shadow);
  color: var(--grey-0);
  max-height: 400px;
  overflow: auto;
  left: 0;

  ul {
    li {
      margin-bottom: 6px;
      font-family: Inter;
      display: flex;
      gap: 10px;

      svg {
        path {
          fill: var(--grey-0);
        }
      }

      &:last-child {
        margin-bottom: 0px;
      }

      .label {
        font-weight: 500;
        width: 80px;
      }
      .toggle {
        margin-top: 2px;
      }
      .row {
        display: flex;
        flex-direction: row;
        align-items: center;
      }
      .icon-container {
        display: flex;
        width: 30px;
        justify-content: center;
      }

      h3 {
        font-size: 16px;
        font-weight: normal;
        display: block;
        margin-bottom: 0;
        line-height: 1.15;
        font-weight: 500;
      }

      p {
        display: block;
        line-height: 1.15;
        font-size: 14px;
      }
    }
  }
`;
